import React from 'react'

import { useBrandAccountId } from '../useBrandAccountId'

export const useStrategyMemosInfiniteQueryKey = () => {
  const brandAccountId = useBrandAccountId()

  return React.useMemo(
    () => ['StrategyMemoListPage_StrategyMemos', { brandAccountId }] as const,
    [brandAccountId],
  )
}
